import { render } from "./ArticleMain.vue?vue&type=template&id=6a6d0efa&scoped=true"
import script from "./ArticleMain.vue?vue&type=script&lang=js"
export * from "./ArticleMain.vue?vue&type=script&lang=js"

import "./ArticleMain.vue?vue&type=style&index=0&id=6a6d0efa&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a6d0efa"]])

export default __exports__